import { render, staticRenderFns } from "./form-checkbox.vue?vue&type=template&id=5ba2bda2&scoped=true&"
import script from "./form-checkbox.vue?vue&type=script&lang=js&"
export * from "./form-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./form-checkbox.vue?vue&type=style&index=0&id=5ba2bda2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba2bda2",
  null
  
)

export default component.exports